/* istanbul ignore file */
import * as React from 'react';
import { Box, Center, Text } from '@chakra-ui/react';

interface Props {
  applicationName: string;
}
export function RouteApplicationPreviewCard(props: Props) {
  const { applicationName } = props;

  return (
    <>
      <Center>
        <Box mx="50px">
          <Text fontSize={16} fontWeight={500}>
            Applicant will now see the account creation screen and then be shown the following
            application:
          </Text>
        </Box>
      </Center>
      <Center>
        <Box mt="50px">
          <Text fontSize={20} fontWeight={500}>
            {applicationName}
          </Text>
        </Box>
      </Center>
    </>
  );
}
